module.exports = __webpack_public_path__ + "img/img-wd.ba9ed3a1.png";